var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "group-quote-member-delete",
      "centered": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.closeModal.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('div', {
    staticClass: "text-center"
  }, [_c('h5', [_c('strong', [_vm._v("Are you sure?")])])]), _c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("This member will be permanently removed from the group")]), _c('div', {
    staticClass: "button-group justify-content-center"
  }, [_c('b-button', {
    staticClass: "modal-button cancel-btn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    staticClass: "modal-button delete",
    on: {
      "click": _vm.deleteMember
    }
  }, [_vm._v("Delete")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }